<template>
    <!-- <q-chip square outline color="primary" size="md">{{ props.one.kind }}</q-chip> -->
    <!-- <div class="barVertical" /> -->
    <q-btn outlined unelevated no-caps :disable="isDisableBtn" @click="onBtn" style="margin: 20px; text-align: left; width: 100%; display: block; border: 1px solid #e0e0e0">
        <!-- <div class="boxRounded"> -->
        <div class="full-screen flex align-left + justify-between" style="margin-top: 14px; width: 100%; vertical-align: middle">
            <p>
                <span v-if="props.isPrivate === true" class="txtNormal text-bold">{{ `개인정보 처리방침 ${props.informData?.agreementVersion}` }}</span>
                <span v-if="props.isPrivate === false" class="txtNormal text-bold">{{ `이용약관 ${props.informData?.termsVersion}` }}</span>
            </p>
            <span>{{ props.informData?.createdTs }}</span>
        </div>
        <!-- </div> -->
    </q-btn>
</template>
// {agreementVersion: '0.2', contents: 'fffff', createdTs: '2023.02.22', s3ObjectName: 'dsafadsfdas'} // { // "seq": 13, // "title": "알림제목12", // "contents": "알림내용12", // "creatorName": "관리자", // "createdTs": "2023.02.23" // },
<script setup>
import { onMounted, computed, ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
    isPrivate: {
        Type: Boolean,
    },
    informData: {
        Type: Object,
    },
    isDisableBtn: {
        Type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['onOpen']);

const onBtn = () => {
    // if (globalStore?.sound && props.options?.sound) {
    //     soundEffect(props.options?.sound)
    // }
    // console.log('--child-onOpen-');
    emit('onOpen', props.informData);
};

// watch(props.kind, (newProps, oldProps) => {
//     console.log('--watch-props-newProps', newProps);
//     console.log('--watch-props-oldProps', oldProps);
// });

onMounted(() => {
    // console.log('--item-informData-', props.informData);
});
////////////////////////////----OnClick----////////////////////////////
// const onMㄴㅇㄹㅇㄴㄹㄴㅇㄹInfo = () => {};
</script>

<style scoped lang="scss">
.purple {
    color: purple;
}
.red {
    color: red;
}
.q-btn {
    border-radius: 10px;
}
</style>
